module.exports = __webpack_public_path__ + "static/media/iphone 11 banner5.d695271f.jpg";